import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=6f85b898&"
import script from "./product-list.vue?vue&type=script&lang=ts&"
export * from "./product-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports